export const ADD_SETTINGS = "ADD_SETTINGS";
